module.exports = __webpack_public_path__ + "static/media/muli-latin-900.66c9d5ed.woff";